<template>
  <section v-if="componentReady" class="container-wrapper thank-you-page">
    <h2 v-if="!isMobile" class="thank-you-page__title">
      {{ title }}
    </h2>
    <h1 v-else class="thank-you-page__title">
      {{ title }}
    </h1>
    <div class="thank-you-page__text subtitle" v-html="text" />
    <div class="thank-you-page__button-wrapper">
      <BaseButton
        class="thank-you-page__button"
        @click="navigateHome"
      >
        {{ buttonText }}
      </BaseButton>
    </div>
  </section>
</template>

<script>
  // Step 6
  import { mapGetters, mapActions } from 'vuex'
  import { DEFAULT_LANG } from '@/helpers/constant'

  export default {
    name: 'ThankYouPage',
    data () {
      return {
        title: '',
        text: '',
        buttonText: '',
        componentReady: false
      }
    },
    computed: {
      ...mapGetters([
        'getAliasParamCity',
        'getAliasParamDealer',
        'isMobile'
      ])
    },
    async created () {
      const { title, text, buttonText } = await this.fetchThankYouPageData()
      this.title = title
      this.text = text
      this.buttonText = buttonText

      this.componentReady = true
    },
    methods: {
      ...mapActions(['fetchThankYouPageData']),
      navigateHome () {
        let langQuery = ''

        if (this.$store.state.currentLang !== DEFAULT_LANG) {
          langQuery = `lang=${this.$store.state.currentLang}`
        }
        let currentRoute

        if (this.getAliasParamCity || this.getAliasParamDealer) {
          currentRoute = `/?city=${this.getAliasParamCity}&dealer=${this.getAliasParamDealer}&${langQuery}`
        } else {
          currentRoute = `/?${langQuery}`
        }

        console.log(currentRoute)
        this.$router.push(currentRoute)
      }
    }
  }
</script>

<style lang="scss">
  .thank-you-page {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    max-width: 680px;
    height: calc(100vh - 200px);
    text-align: center;

    @include mobile {
      max-width: 100%;
    }

    &__title {
      margin-bottom: 40px;

      @include mobile {
        margin-bottom: 17px;
      }
    }

    &__text {
      font-family: "FavoritBookC", Arial, Helvetica, sans-serif;
      color: rgba($c-black, 0.6);

      @include tablet {
        max-width: 579px;
      }

      @include mobile {
        max-width: 100%;
      }
    }

    &__button {
      &-wrapper {
        display: flex;
        justify-content: center;
      }

      margin-top: 60px;

      @include mobile {
        margin-top: 40px;
      }
    }
  }
</style>
